import { humanize, addForwardSlash, addDash, titleCase } from './enums';

export default { humanize, addForwardSlash, addDash, titleCase };
